module.exports = __webpack_public_path__ + "img/content-7.a7173011.png";